import type { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { sendSentryClientError } from 'shared/lib';

import { ErrorBoundaryFallback } from './ErrorBoundaryFallback';

export const ErrorBoundaryFallbackProvider: FC = ({ children }) => (
  <ErrorBoundary
    fallbackRender={ErrorBoundaryFallback}
    onError={(error: Error, info: { componentStack: string }) =>
      sendSentryClientError(error, { ...info, ErrorBoundaryId: 'Component' }, { level: 'fatal' })
    }
  >
    {children}
  </ErrorBoundary>
);
